import { EWalletId, ProviderEvents } from '@ankr.com/provider';
import { createListenerMiddleware } from '@reduxjs/toolkit';

import { MultiService } from 'modules/api/MultiService';
import { RootState } from 'store';
import { getProviderManager } from 'modules/api/getProviderManager';
import { initAuthListeners } from 'modules/auth/store/listeners';
import { initTFAListeners } from 'modules/tfa/store/listeners';
import { isEventProvider } from 'store/utils/isEventProvider';
import { signOut } from 'modules/auth/actions/signOut';

export const listenerMiddleware = createListenerMiddleware<RootState>();

initAuthListeners({ listenerMiddleware });

initTFAListeners({ listenerMiddleware });

listenerMiddleware.startListening({
  matcher: signOut.matchFulfilled,
  effect: async () => {
    const service = MultiService.getWeb3Service();

    if (service) {
      const providerManager = getProviderManager();
      const ethWeb3KeyProvider = await providerManager.getETHWriteProvider(
        EWalletId.injected,
      );
      const provider = ethWeb3KeyProvider.getWeb3()?.currentProvider;

      if (isEventProvider(provider)) {
        provider.removeAllListeners(ProviderEvents.Disconnect);
        provider.removeAllListeners(ProviderEvents.ChainChanged);
      }
    }

    MultiService.removeServices();
  },
});

listenerMiddleware.startListening({
  matcher: signOut.matchFulfilled,
  effect: async (_action, { cancelActiveListeners }) => {
    cancelActiveListeners();
  },
});
